import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // http://localhost:8080/api
});

// ✅ THIS IS WHERE YOUR CODE GOES
api.interceptors.request.use((config) => {

  const jwt = localStorage.getItem("token"); // org login token
  const attendanceToken = sessionStorage.getItem("ATTENDANCE_TOKEN");

  if (jwt) {
    // ORG USER → JWT ALWAYS WINS
    config.headers.Authorization = `Bearer ${jwt}`;
  } else if (attendanceToken) {
    // DELEGATE ONLY
    config.headers.Authorization = `AttendanceToken ${attendanceToken}`;
  }

  return config;
});

export default api;
